export const appScheme = process.env.ENVIRONMENT === 'production' ? 'vtail://' : 'vtailtest://';
